import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import {
    IsimpleOption,
    filterOptionsBySearch,
    toggleOption,
    toggleSelectAllVisible,
    areAllVisibleSelected
} from './multiSelectFilterUtil';

interface Iprops {
    values: IsimpleOption[];
    options: IsimpleOption[];
    onChange: (selected: IsimpleOption[]) => void;
    selectAllLabel: string;
    searchPlaceholder: string;
    emptyLabel: string;
}

/*
 * Search + Select All + checkbox list. Presentational: the parent owns the
 * selection, only the search term is local state.
 *
 * Ported from the FSE app (MMG-4223). Diverged for Web: FontAwesome instead of
 * FSE's Icon component, and the labels are passed in already translated rather
 * than hardcoded - the FSE toolbar is untranslated, Web's is not.
 */
const MultiSelectFilterList: React.FC<Iprops> = ({
    values,
    options,
    onChange,
    selectAllLabel,
    searchPlaceholder,
    emptyLabel
}) => {
    const [search, setSearch] = React.useState('');

    const visibleOptions = filterOptionsBySearch(options, search);
    const allVisibleSelected = areAllVisibleSelected(values, visibleOptions);

    return (
        <div className="multi-select-list">
            <div className="multi-select-search">
                <FontAwesomeIcon
                    icon={faSearch}
                    className="multi-select-search-icon"
                />
                <input
                    type="text"
                    value={search}
                    placeholder={searchPlaceholder}
                    onChange={e => setSearch(e.target.value)}
                    // Bootstrap's dropdown listens for keydown on the menu and
                    // would steal typing (and Escape) from this input.
                    onKeyDown={e => e.stopPropagation()}
                />
            </div>

            {visibleOptions.length > 0 && (
                <label className="multi-select-option select-all">
                    <input
                        type="checkbox"
                        checked={allVisibleSelected}
                        onChange={() =>
                            onChange(
                                toggleSelectAllVisible(values, visibleOptions)
                            )
                        }
                    />
                    <span className="multi-select-option-label">
                        {selectAllLabel}
                    </span>
                </label>
            )}

            <div className="multi-select-option-list">
                {visibleOptions.length === 0 ? (
                    <div className="multi-select-empty">{emptyLabel}</div>
                ) : (
                    visibleOptions.map(option => (
                        <label
                            key={option.value}
                            className="multi-select-option"
                        >
                            <input
                                type="checkbox"
                                checked={values.some(
                                    item => item.value === option.value
                                )}
                                onChange={() =>
                                    onChange(toggleOption(values, option))
                                }
                            />
                            <span className="multi-select-option-label">
                                {option.label}
                            </span>
                        </label>
                    ))
                )}
            </div>
        </div>
    );
};

export default MultiSelectFilterList;
